import { ZodType } from 'zod'

// Attach a Promise-based validate method to all Zod schemas at runtime.
// This mirrors the common `.validate()` behavior expected by the Cypress tests.
;(ZodType.prototype as any).validate = function (value: unknown, options?: any) {
    const input = options && options.context && typeof value === 'object' && value !== null
        ? { ...(value as object), ...options.context }
        : options && options.context
        ? { ...options.context }
        : value

    const res = (this as ZodType).safeParse(input)
    if (res.success) {
        return Promise.resolve(res.data)
    }
    return Promise.reject(res.error)
}

// Helper to attach validate directly to a schema instance (works even if prototype
// patching didn't run early enough).
export const withValidate = <T extends ZodType>(schema: T): T & { validate: (v: unknown, opts?: any) => Promise<any> } => {
    ;(schema as any).validate = function (value: unknown, options?: any) {
        const input = options && options.context && typeof value === 'object' && value !== null
            ? { ...(value as object), ...options.context }
            : options && options.context
            ? { ...options.context }
            : value
        const res = schema.safeParse(input)
        if (res.success) {
            return Promise.resolve(res.data)
        }
        return Promise.reject(res.error)
    }
    return schema as any
}

export {}
